import {ApolloClient, createHttpLink} from '@apollo/client/core';
import {createPersistedQueryLink} from "apollo-link-persisted-queries";
import {InMemoryCache} from '@apollo/client/cache';
import {siteKey} from "./WooCommerce/wooConfig";

import possibleTypes from './possibleTypes.json';

const date = new Date();
const dayMonthYearFormatted = `${date.getHours()}${date.getDate()}${date.getMonth()}${date.getYear()}`;

const uri = createPersistedQueryLink({useGETForHashedQueries: true}).concat(createHttpLink({ uri: `/graphql?d=${siteKey}${dayMonthYearFormatted}`}));
const client = new ApolloClient({
    link: uri,
    cache: new InMemoryCache({possibleTypes}),
});

export default client;